<script setup lang="ts">

import { formatNumberFullTruncate } from '@/helpers/utils'
import CoinIcon from '@/components/icons/CoinIcon.vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { T } from '@tolgee/vue'
import ShareImage from '@/assets/images/phone.png'
import TGEStoryImage from '@/assets/images/tge-story.jpg'
import { ref } from 'vue'
import webapp from '@/services/webapp'
import api from '@/services/api'
import { sleep } from '@/services/helper'
import { useTaskList } from '@/composables/game/tasks'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  (event: 'hide'): void,
  (event: 'success'): void,
}>()

const { shareTaskReward, claimStoryTask, isShareTaskClaimed, shareStoryDone } = useTaskList()

const isLoading = ref<boolean>(false)

async function generateShareImageAndSave(): Promise<string | undefined> {
  const response = await fetch(TGEStoryImage)
  const blob = await response.blob()
  console.log(blob)
  if (blob) {
    const file = new File([blob], 'share-image.png', { lastModified: new Date().getTime(), type: blob.type })
    const { uploadUrl, fileUrl } = await api.createFileUploadUrl({
      usage: 'story',
      contentType: file.type as `image/${string}`,
      contentLength: file.size,
    })
    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
    })
    return fileUrl
  } else {
    console.error('Error generating the blob')
  }
  return ''
}

async function check() {
  isLoading.value = true
  if ((!shareStoryDone.value || isShareTaskClaimed.value)) {
    const url = await generateShareImageAndSave()
    await sleep(1000)
    if (url) {
      webapp.shareToStory(url, {
        text: `$DROPEE airdrop is coming in Q1 2025! 🪂Play now and secure your spot before it’s too late. 🌟 Your activity = Bigger rewards. Start today! 🔥`,
      })
      setTimeout(() => shareStoryDone.value = true, 150)
      isLoading.value = false
    } else {
      console.error('Error with the image url')
    }
  } else if (!isShareTaskClaimed.value) {
    await claimStoryTask()
    isLoading.value = false
  }
}
function onHide() {
  emit('hide')
}

</script>
<template>
  <TheBottomSheet
    :show="show"
    @hide="onHide"
  >
    <div class="flex flex-col gap-y-8">
      <div
        class="w-full flex flex-col items-center gap-y-6"
      >
        <img
          class="w-[120px] h-[120px] min-w-[120px] object-cover"
          :src="ShareImage"
        >
        <div
          class="text-center text-2xl font-semibold -tracking-[0.48px] text-light-white"
        >
          <T
            key-name="task.story.title"
            default-value="Share a story"
          />
        </div>
        <div
          class="text-center text-sm font-medium -tracking-[0.48px] text-light-white max-w-[379px]"
        >
          <T
            key-name="task.story.tge_description"
            default-value="Share a story about our upcoming Dropee TGE!"
          />
        </div>
        <div class="flex items-center gap-x-2">
          <CoinIcon class="size-8 min-w-8 text-white" />
          <span
            class="text-xl leading-6 font-bold -tracking-[0.4px] text-green-primary"
          >+{{ formatNumberFullTruncate(shareTaskReward) }}</span>
        </div>
      </div>
      <BaseButton
        class="w-full"
        :loading="isLoading"
        @click="check"
      >
        <T
          v-if="!shareStoryDone || isShareTaskClaimed"
          key-name="task.story.cta"
          default-value="Share story"
        />
        <T
          v-else
          key-name="task.story.claim"
          default-value="Claim"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>
